import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {toWidget, toWidgetEditable} from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import PollCommand from './PollCommand';

export default class PollEditing extends Plugin {
    static get requires() {
        return [Widget];
    }

    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertPoll', new PollCommand(this.editor));
    }

    _defineSchema() {
        const schema = this.editor.model.schema;

        schema.register('pollBox', {
            // Behaves like a self-contained object (e.g. an image).
            isObject: true,
            // Allow in places where other blocks are allowed (e.g. directly in the root).
            allowWhere: '$block'
        });

        schema.register( 'poll-front-component', {
            isLimit: true,
            allowIn: 'pollBox',
            allowAttributes: [':poll-id']
        } );
    }

    _defineConverters() {                                                      // MODIFIED
        const conversion = this.editor.conversion;


        conversion.for( 'upcast' ).elementToElement( {
            model: 'pollBox',
            view: {
                name: 'div',
                classes: 'vue-code-two'
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'pollBox',
            view: {
                name: 'div',
                classes: 'vue-code-two'
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'pollBox',
            view: ( modelElement,  { writer: viewWriter } ) => {
                const section = viewWriter.createContainerElement( 'div', { class: 'vue-code-two' } );
                return toWidget( section, viewWriter );
            }
        } );

        conversion.for( 'upcast' ).elementToElement( {
            model: 'poll-front-component',
            view: {
                name: 'poll-front-component',
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'poll-front-component',
            view: {
                name: 'poll-front-component',
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'poll-front-component',
            view: ( modelElement, { writer: viewWriter } ) => {

                const slider_fotoram = viewWriter.createEditableElement( 'poll-front-component',);

                return toWidget( slider_fotoram, viewWriter );
            }
        } );
        conversion.for('downcast').attributeToAttribute({
            model: {
                name: 'poll-front-component',
                key: ':poll-id'
            },
            view: {
                name: 'poll-front-component',
                key: ':poll-id'
            },
            converterPriority: 'low'
        });

        conversion.for('upcast').attributeToAttribute({
            model: {
                name: 'poll-front-component',
                key: ':poll-id'
            },
            view: {
                name: 'poll-front-component',
                key: ':poll-id'
            },
            converterPriority: 'low'
        });

    }
}
